import {Injectable} from '@angular/core';
import {DtoSchema} from '../../models/schemas.model';
import {HttpClientService} from '../httpClient/httpclient.service';



@Injectable()
export class SchemaService {
  schemas: Map<string, DtoSchema>;

  constructor(private srvHttp: HttpClientService) {
    this.schemas = new Map();
  }

  deploySchema(baseUrl: string, dtoName: string) {
     return this.srvHttp.get(baseUrl + '/schema/' + dtoName)
        .map(res => {
          let dtoSchema: DtoSchema = {
            dtoName: dtoName,
            fieldSchema: new Map()
          };
          console.log(res);
          for (let k in res) {
            dtoSchema.fieldSchema.set(k, res[k]);
          }
          this.schemas.set(baseUrl, dtoSchema);
          console.log(this.schemas);
        });
  }

  getSchema(baseUrl: string, dtoName: string) : DtoSchema {
    return this.schemas.get(baseUrl);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/utils/schema.service.ts